import React from 'react';
import { Tooltip } from 'antd';

const ProjectRoleTooltip = (
  <Tooltip title="Used to create working group contact lists. Project roles do not impact Gateway edit / view permissions. Permissions are managed in the Groups tab.">
    <span className="appkiticon icon-information-fill" />
  </Tooltip>
);

export default ProjectRoleTooltip;
